export const categoryEnumOptions = [
  { id: 'U12', label: 'U12' },
  { id: 'U14', label: 'U14' },
  { id: 'U16', label: 'U16' },
  { id: 'U18', label: 'U18' },
  { id: 'U20', label: 'U20' },
  { id: 'Prima_Squadra', label: 'Prima Squadra' }
];